import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';
import { REGION_API_TOKEN } from './types';
import { AuthInterceptor } from './auth/interceptors/auth-interceptor.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    exports: [BrowserAnimationsModule, HttpClientModule],
    providers: [
        {
            provide: REGION_API_TOKEN,
            useValue: environment.api,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
})
export class CoreModule {}
